export default __webpack_public_path__ + "static/media/cow_gray.71a02b46.svg";